<template>
    <div class="main" style="overflow: visible;">
      <div
        v-bind:style="{ height: '100px', 'background-color': '#fff' }"
      ></div>
      <HeaderComponent
        :text="$t('text.booking_confirmation')"
        backgroundColor="#fff"
      />
      <Transition appear name="fade">
        <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
            <b-spinner
                variant="dark"
                label="Spinning"
                class="login-loader"
            ></b-spinner>
        </div>
        </Transition>
        <Transition appear name="fade">
          <div v-if="!loading && booking" class="main-div">
            
            <div class="body-container">
            <p>{{$t('text.booking_completed_intro_text_1')}}</p>
            <p>{{$t('text.booking_completed_intro_text_2')}} <a class="underline" href="mailto: hjortronvagen15@gmail.com">hjortronvagen15@gmail.com</a>. {{$t('text.booking_completed_intro_text_3')}}</p>

            <p class="info-header">
                <strong>{{$t('text.name')}}</strong>
                <br>{{booking.getFullName()}}
            </p>

            <p class="info-header">
                <strong>{{$t('text.booking_number')}}</strong>
                <br>{{booking.id}}
            </p>
            
            <p class="info-header">
                <strong>{{$t('text.cabin')}}</strong>
                <br>{{getCabinText(booking.cabin)}}
            </p>

            <p class="info-header">
                <strong>{{$t('text.date')}}</strong>
                <br>{{$t('text.from')}} {{booking.getStartDateString()}} {{$t('text.kl')}} 14:00 {{$t('text.to')}} {{booking.getEndDateString()}} {{$t('text.kl')}} 11:00
            </p>

            <p class="info-header">
                <strong>{{$t('text.address')}}</strong>
                <br><a class="underline" href="http://maps.google.com/?q=Hjortronvägen 15, 780 91 Sälen">Hjortronvägen 15, 780 91 Sälen</a>
            </p>
            
            <p v-if="booking.notes" class="info-header">
                <strong>{{$t('text.message')}}</strong>
                <br>{{booking.notes}}
            </p>

            <p class="info-header">
                <strong>{{$t('text.price')}}</strong>
                <br>{{booking.price}} {{$t('text.sek')}}
            </p>
            <p>
                {{$t('text.booking_completed_payment_text_1')}} <strong>Bergslagens Sparbank</strong><br>
                {{$t('text.booking_completed_payment_text_2')}}: <strong>8191-9 794 217 007-2</strong><br>
                Kontohavare A Midhamre. <strong>{{$t('text.booking_completed_payment_text_3')}}</strong>
            </p>
            
            <p>
                <strong>{{$t('text.booking_completed_payment_text_4')}}</strong><br>
                {{$t('text.booking_completed_payment_text_4_5')}}<br>
                {{$t('text.booking_completed_payment_text_5')}}<br>
                {{$t('text.booking_completed_payment_text_6')}}<br>
                <br>
                <strong>{{$t('text.booking_completed_arrival_text_1')}}</strong><br>
                {{$t('text.booking_completed_arrival_text_2')}}<br>
                {{$t('text.booking_completed_arrival_text_3')}}<br>
                {{getCabinInstructions(booking.cabin)}}<br>
                <strong>{{$t('text.booking_completed_arrival_text_5')}}</strong><br>
                <em>{{$t('text.booking_completed_arrival_text_6')}}</em><br>
                <br>
                <strong>{{$t('text.booking_completed_leaving_text_1')}}</strong><br>
                {{$t('text.booking_completed_leaving_text_2')}}<br>
                {{$t('text.booking_completed_leaving_text_3')}}<br>
                {{$t('text.booking_completed_leaving_text_4')}}<br>
                {{$t('text.booking_completed_leaving_text_5')}}<br>
                {{$t('text.booking_completed_leaving_text_6')}}<br>
                {{$t('text.booking_completed_leaving_text_7')}}<br>
                <strong>{{$t('text.booking_completed_leaving_text_8')}}</strong><br>
                <br>
                <strong>{{$t('text.booking_completed_outro_text_1')}}</strong><br>
                <br>
                {{$t('text.booking_completed_outro_text_2')}} Margareta <a class="underline" href="tel: 0723069107">072 306 91 07</a>, Kerstin <a class="underline" href="tel: 0705664485">070 566 44 85</a>, Lars <a class="underline" href="tel: 0703313525">070 33 135 25</a>, Amanda <a class="underline" href="tel: 0706425725">070 642 57 25</a>, {{$t('text.booking_completed_outro_text_3')}} <a class="underline" href="mailto: hjortronvagen15@gmail.com">hjortronvagen15@gmail.com</a><br>

            </p>
            

            </div>            
        </div>
      </Transition>
    </div>
  </template>
  
<script>
import HeaderComponent from "../components/HeaderComponent.vue";
import BookingApiService from "../../services/booking_api_service";
import Booking from "../../models/booking";
  
  export default {
      name: "BookingConfirmationPage",
      components: {
          HeaderComponent,
      },
      data() {
        return {
            booking: null,
            loading: false,
        }
      },
      methods: {
        async fetchBooking() {
            this.loading = true;
            try {
                const data = await BookingApiService.get_confirmation(this.$route.query.uuid);
                this.booking = new Booking(data.data);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.$router.push("/404");
            }
        },
        getCabinText(cabin) {
            switch (parseInt(cabin)) {
                case 0: 
                    return this.$t('text.family_cabin')
                case 1: 
                    return this.$t('text.large_cabin')
                default:
                    return this.$t('text.small_cabin')
           }
        },
        getCabinInstructions(cabin) {
            switch (parseInt(cabin)) {
                case 0: 
                    return ''
                case 1: 
                    return this.$t('text.large_cabin_instructions')
                default:
                    return this.$t('text.small_cabin_instructions')
           }
        },
      },
      mounted() {
        if (this.$route.query.uuid) {
            this.fetchBooking()  
        } else {
            this.$router.push('/')
        }
      }
  };
  </script>
  
<style scoped>
  
    strong {
      margin-top:20px;
    }
    a {
      color: #000;
      text-decoration: none;
    }
    .main {
        width: 100%;
        background-color: #fff;
    }
    .main-div {
        max-width: 1100px;
        margin: auto;
        background-color: #fff;
    }
    .body-container {
        padding-top: 30px;
        padding-left: 8%;
        padding-right: 8%;
        padding-bottom: 40px;
        max-width: 100%;
    }
    .info-header {
      margin-top: 20px;
    }
    .spacer {
      height: 40px;
    }
    .underline {
      text-decoration: underline;
    }
  
</style>
  